/**
 * @name 导入无需服务端获取的微应用
 */
import noAuthApps from '@/util/appConfig';
import Cookies from 'js-cookie';
import {
    findMenuByUser
} from '@/service/api';
import {mapGetters} from "vuex";
import store from "@/store";

// const menu = {
export default {
    namespaced: true,
    state: {
        projects: [], //项目集合
        apps: [], //应用注册表数据
        menus: [], //菜单数据 路径包含子应用路由前缀
        routes: [], //路由数据 路径不包含子应用路由前缀
        appMenus: [], //应用菜单数据  路径不包含子应用路由前缀
        selectedApp: '', //当前选中应用
        selectedMenuId: '', //当前选中菜单
        currentPath: [], //面包屑集合
        openedSubmenuArr: [], //展开的菜单集合
    },
    mutations: {
        SET_PROJECTS: (state, data) => {
            state.projects = data;
        },
        SET_APPS: (state, data) => {
            state.apps = data;
        },
        SET_MENUS(state, data) {
            state.menus = data;
        },
        SET_ROUTES(state, data) {
            state.routes = data;
        },
        SET_APPMENUS(state, data) {
            state.appMenus = data;
        },
        SET_SELECTED_APP(state, data) {
            state.selectedApp = data;
        },
        SET_SELECTED_MENUID(state, data) {
            state.selectedMenuId = data;
        },
        SET_CURRENTPATH(state, data) {
            state.currentPath = data;
        },
        SET_OPENEDSUBMENUARR(state, data) {
            state.openedSubmenuArr = data;
        },
    },
    actions: {
        // 根据用户id，获取用户权限（包含注册子应用和子应用的菜单）保存至store
        setAppsMenuData({
                            commit
                        }, userInfo) {
            return new Promise((resolve, reject) => {
                findMenuByUser(userInfo).then(function (response) {
                   let appType = -1;
                   if (userInfo.appType){
                       appType = userInfo.appType
                   }
                    const data = response.data;
                    let projectList = [],
                        appList = [];
                    if (appType == 1) {
                        projectList = data.projectList.filter(item => item.name == 'module-base')
                        appList = data.appList.filter(item => {
                            let children = item.menuTreeList.filter(subItem => subItem.projectName == 'module-base' && subItem.name == 'schoolMain')
                            item.menuTreeList = children.length > 0 ? children : []
                            if (item.menuTreeList.length > 0) {
                                return item
                            }
                        })
                    } else {
                        projectList = data.projectList
                        appList = data.appList
                    }

                    let curApp = projectList.filter((item) => {
                        return item.name == noAuthApps[0].name;
                    })[0];
                    if (!curApp) {
                        projectList = projectList.concat(noAuthApps);
                    }
                    if (projectList) {
                        commit('SET_PROJECTS', projectList);
                        commit('SET_APPS', appList);
                        resolve();
                    } else {
                        let error = {};
                        error.message = '您还没有权限，请联系管理员！';
                        reject(error);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },
        // 推入用户菜单
        setUserMenu({
                        commit
                    }, data) {
            commit('SET_MENUS', data);
        },
        // 设置当前选中应用
        setSelectedApp({
                           commit
                       }, data) {
            commit('SET_SELECTED_APP', data);
        },
        // 设置当前选中菜单
        setSelectedMenuId({
                              commit
                          }, data) {
            commit('SET_SELECTED_MENUID', data);
        },
        // 设置面包屑集合
        setCurrentPath({
                           commit
                       }, data) {
            commit('SET_CURRENTPATH', data);
        },
        // 设置展开的菜单集合
        setOpenedSubmenuArr({
                                commit
                            }, data) {
            commit('SET_OPENEDSUBMENUARR', data);
        }
    }
};

// export default menu;